const COOKIE_STORAGE_KEY = 'supertokens-electron-cookies'

function getCookiesFromStorage(): string {
  const cookiesFromStorage = window.localStorage.getItem(COOKIE_STORAGE_KEY)
  if (cookiesFromStorage === null) {
    window.localStorage.setItem(COOKIE_STORAGE_KEY, '[]')
    return ''
  }

  const cookieArray: string[] = JSON.parse(cookiesFromStorage)
  const now = Date.now()
  const validCookies = cookieArray.filter((cookieString) => {
    const expiresMatch = cookieString.match(/expires=([^;]+)/i)
    if (!expiresMatch) return true
    return new Date(expiresMatch[1]).getTime() > now
  })

  if (validCookies.length !== cookieArray.length) {
    window.localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(validCookies))
  }

  return validCookies.join('; ')
}

async function setCookieToStorage(cookieString: string): Promise<void> {
  const cookieName = cookieString.split(';')[0].split('=')[0].trim()
  const cookiesFromStorage = window.localStorage.getItem(COOKIE_STORAGE_KEY)
  const cookieArray: string[] = cookiesFromStorage ? JSON.parse(cookiesFromStorage) : []

  const index = cookieArray.findIndex((c) => c.split(';')[0].split('=')[0].trim() === cookieName)
  if (index !== -1) {
    cookieArray[index] = cookieString
  } else {
    cookieArray.push(cookieString)
  }

  window.localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(cookieArray))
}

export function getCookieHandler(original: any) {
  return {
    ...original,
    getCookie: async (): Promise<string> => {
      return getCookiesFromStorage()
    },
    setCookie: async (cookieString: string): Promise<void> => {
      await setCookieToStorage(cookieString)
    },
  }
}